var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasinijada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18125_12194",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18125_12194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.3845 20V19H11.5V15.2463C10.6192 15.0884 9.84833 14.7201 9.1875 14.1412C8.52667 13.5624 8.07183 12.8448 7.823 11.9885C6.76533 11.8642 5.86375 11.4305 5.11825 10.6875C4.37275 9.9445 4 9.04867 4 8V7C4 6.732 4.09967 6.49833 4.299 6.299C4.49833 6.09967 4.732 6 5 6H7.65375V4H16.3462V6H19C19.268 6 19.5017 6.09967 19.701 6.299C19.9003 6.49833 20 6.732 20 7V8C20 9.04867 19.6273 9.9445 18.8818 10.6875C18.1363 11.4305 17.2347 11.8642 16.177 11.9885C15.9282 12.8448 15.4733 13.5624 14.8125 14.1412C14.1517 14.7201 13.3808 15.0884 12.5 15.2463V19H15.6155V20H8.3845ZM7.65375 10.9155V7H5V8C5 8.7615 5.25383 9.41567 5.7615 9.9625C6.26917 10.5093 6.89992 10.827 7.65375 10.9155ZM16.3462 10.9155C17.1001 10.827 17.7308 10.5093 18.2385 9.9625C18.7462 9.41567 19 8.7615 19 8V7H16.3462V10.9155Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasinijada);
export default __webpack_public_path__ + "static/media/masinijada.4a4d3d40f541d1e22e6d5877f398639c.svg";
export { ForwardRef as ReactComponent };